<template lang="html">
  <div class="new-kid" @click.prevent="toggleNewKidForm">
    <img src="../../assets/new-kid.svg" alt="Add kid" />

    <div class="text">
      <h3>Invite a Kid</h3>
    </div>
  </div>
</template>

<script>
  export default {
    name: "New",
    methods: {
      toggleNewKidForm() {
        this.$store.commit("toggleNewKidForm");
      },
    },
  };
</script>

<style scoped lang="css">
  .new-kid {
    display: inline-block;
    margin: 20px;
    padding: 10px;
    border: 2px solid #8c5925;
    width: 500px;
    cursor: pointer;
  }

  .new-kid img {
    width: 150px;
    border: 1px solid #b2773c;
  }

  .new-kid .text {
    display: inline-block;
    padding-left: 10px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Kids/New.vue